/** Dev mode → Tasks: what the AI workers are doing, from Kiaan Work. */
import { getDevTasks } from '../kiaanApi';
import { DevState, useDevData } from './useDevData';

const PILL: Record<string, string> = { done: 'kw-ok', merged: 'kw-ok', working: 'kw-wip', doing: 'kw-wip', planning: 'kw-wip', waiting: 'kw-wt', 'tests running': 'kw-wt', blocked: 'kw-bad', failed: 'kw-bad' };

export function Tasks() {
  const { data, loading, error } = useDevData(getDevTasks);
  if (!data) return <DevState loading={loading} error={error} />;
  return (
    <div className="kw-grid" style={{ gridTemplateColumns: '1fr' }}>
      <div className="kw-box">
        <h4>Tasks <span>{data.length}</span></h4>
        {data.length === 0 && <div className="kw-small">No tasks yet. Ask Kiaan for something in the Kiaan tab.</div>}
        {data.map((t) => (
          <div key={t.id} className="kw-row">
            {t.title}
            {t.assignee && <span className="kw-small">· {t.assignee}</span>}
            {t.branch && <span className="kw-mono kw-small">· {t.branch}</span>}
            <span className={`kw-pill kw-ml ${PILL[t.status.toLowerCase()] ?? ''}`}>{t.status}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
